import { Role, role } from "./role";
import { UserStatus } from "./userStatus";
import { Identifiable } from "./identifiable";
import { id } from "./id";

type UserAccount = {
  name: string;
  user: { smallPicture: string };
  status: UserStatus;
  planzoneRole: Identifiable<Role>;
};

const userAccount: UserAccount = {
  name: "",
  user: { smallPicture: "" },
  status: UserStatus.ACTIVE,
  planzoneRole: { ...role, uuid: id },
};

export type { UserAccount };

export { userAccount };
